import type { AnalyticsInstance, AnalyticsPlugin } from 'analytics';

type AdobeWindowT = {
  analyticsDataLayer: Record<string, unknown>;
  s: unknown;
} & Window;

type ConfigT = { enabled: boolean; };

type PayloadT = {
  event: string;
  properties: Record<string, unknown>;
  traits: Record<string, unknown>;
};

type EventCallbackT = {
  instance: AnalyticsInstance;
  payload: PayloadT;
};

declare let window: AdobeWindowT;

const adobeLaunchURL: string = import.meta.env.VITE_ADOBE_LAUNCH_URL || '';

export function buildAdobePlugin(config: ConfigT): AnalyticsPlugin {
  const enabled = config.enabled && !!adobeLaunchURL;

  if (config.enabled && !adobeLaunchURL) {
    console.warn('Adobe not configured');
  }

  return {
    config: { enabled },
    identify: <T extends EventCallbackT>({ payload }: T) => {
      if (payload.traits) {
        window.analyticsDataLayer = payload.traits;
      } else if (!window.analyticsDataLayer) {
        window.analyticsDataLayer = {};
      }
    },
    initialize: () => {
      const adobeLaunch = document.createElement('script');

      adobeLaunch.setAttribute('src', adobeLaunchURL);
      document.head.prepend(adobeLaunch);
    },
    loaded: () => !!window.s,
    name: 'adobe',
    track: <T extends EventCallbackT>({ payload, instance }: T) => {
      window.analyticsDataLayer = instance.user().traits ?? window.analyticsDataLayer ?? {};
      document.body.dispatchEvent(
        new CustomEvent(payload.event, {
          bubbles: true,
          composed: true,
          detail: payload.properties,
        }),
      );
    },
  };
}
